import { tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { CATALOGUE_IDS } from './catalogue-ids';
import {
  CatalogItem,
  CataloguesHttpService,
} from 'banesco-catalogues-api';

@Injectable()
export class BnCataloguesService {
  banks?: CatalogItem[];
  regionalBanks?: CatalogItem[];
  idTypes?: CatalogItem[];
  currencies?: CatalogItem[];
  productTypes?: CatalogItem[];
  beneficiaryTypes?: CatalogItem[];
  beneficiaryProductTypes?: CatalogItem[];
  localSendingChannels?: CatalogItem[];
  regionalSendingChannels?: CatalogItem[];
  internationalSendingChannels?: CatalogItem[];
  localTransferCurrencies?: CatalogItem[];
  serviceCategories?: CatalogItem[];
  serviceBiller?: CatalogItem[];
  internationalReasons?: CatalogItem[];

  constructor(private catalogsHTTPService: CataloguesHttpService) {}

  getBanks(): Observable<CatalogItem[]> {
    return this.banks?.length
      ? of(this.banks)
      : this.catalogsHTTPService.getCatalogById({ id: CATALOGUE_IDS.BANKS }).pipe(
          tap((values) => {
            this.banks = values;
          }),
        );
  }

  getRegionalBanks(): Observable<CatalogItem[]> {
    return this.regionalBanks?.length
      ? of(this.regionalBanks)
      : this.catalogsHTTPService.getCatalogById({ id: CATALOGUE_IDS.REGIONAL_BANKS }).pipe(
          tap((values) => {
            this.regionalBanks = values;
          }),
        );
  }

  getCurrencies(): Observable<CatalogItem[]> {
    return this.currencies?.length
      ? of(this.currencies)
      : this.catalogsHTTPService.getCatalogById({ id: CATALOGUE_IDS.BANESCO_CURRENCY }).pipe(
          tap((values) => {
            this.currencies = values;
          }),
        );
  }

  getLocalTransferCurrencies(): Observable<CatalogItem[]> {
    return this.localTransferCurrencies?.length
      ? of(this.localTransferCurrencies)
      : this.catalogsHTTPService.getCatalogById({ id: CATALOGUE_IDS.LOCAL_TRANSFER_CURRENCIES }).pipe(
          tap((values) => {
            this.currencies = values;
          }),
        );
  }

  getProductTypes(): Observable<CatalogItem[]> {
    return this.productTypes?.length
      ? of(this.productTypes)
      : this.catalogsHTTPService.getCatalogById({ id: CATALOGUE_IDS.BANESCO_PRODUCTS }).pipe(
          tap((values) => {
            this.productTypes = values;
          }),
        );
  }

  getBeneficiaryTypes(): Observable<CatalogItem[]> {
    return this.beneficiaryTypes?.length
      ? of(this.beneficiaryTypes)
      : this.catalogsHTTPService.getCatalogByGroupId({ groupId: CATALOGUE_IDS.BENEFICIARY_TYPES }).pipe(
          tap((values) => {
            this.beneficiaryTypes = values;
          }),
        );
  }

  getBeneficiaryProductTypes(): Observable<CatalogItem[]> {
    return this.beneficiaryProductTypes?.length
      ? of(this.beneficiaryProductTypes)
      : this.catalogsHTTPService.getCatalogById({ id: CATALOGUE_IDS.BENEFICIARY_PRODUCT_TYPES }).pipe(
          tap((values) => {
            this.beneficiaryProductTypes = values;
          }),
        );
  }

  getIdTypes(): Observable<CatalogItem[]> {
    return this.idTypes?.length
      ? of(this.idTypes)
      : this.catalogsHTTPService.getCatalogById({ id: CATALOGUE_IDS.ID_TYPES }).pipe(
          tap((values) => {
            this.idTypes = values;
          }),
        );
  }

  getLocalSendingChannels(): Observable<CatalogItem[]> {
    return this.localSendingChannels?.length
      ? of(this.localSendingChannels)
      : this.catalogsHTTPService.getCatalogById({ id: CATALOGUE_IDS.LOCAL_SENDING_CHANNEL }).pipe(
          tap((values) => {
            this.localSendingChannels = values;
          }),
        );
  }

  getRegionalSendingChannels(): Observable<CatalogItem[]> {
    return this.regionalSendingChannels?.length
      ? of(this.regionalSendingChannels)
      : this.catalogsHTTPService.getCatalogById({ id: CATALOGUE_IDS.REGIONAL_SENDING_CHANNEL }).pipe(
          tap((values) => {
            this.regionalSendingChannels = values;
          }),
        );
  }

  getCollectors(): Observable<CatalogItem[]> {
    return this.catalogsHTTPService.getCatalogByGroupId({ groupId: CATALOGUE_IDS.TAX_COLLECTORS });
  }

  getInternationalSendingChannels(): Observable<CatalogItem[]> {
    return this.internationalSendingChannels?.length
      ? of(this.internationalSendingChannels)
      : this.catalogsHTTPService.getCatalogById({ id: CATALOGUE_IDS.INTERNATIONAL_SENDING_CHANNEL }).pipe(
          tap((values) => {
            this.internationalSendingChannels = values;
          }),
        );
  }

  getServiceCategories(): Observable<CatalogItem[]> {
    return this.serviceCategories?.length
      ? of(this.serviceCategories)
      : this.catalogsHTTPService.getCatalogByGroupId({ groupId: CATALOGUE_IDS.SERVICE_CATEGORIES }).pipe(
          tap((values) => {
            this.serviceCategories = values;
          }),
        );
  }

  getServiceBiller(idCode: string): Observable<CatalogItem[]> {
    return this.catalogsHTTPService.getCatalogById({ id: idCode }).pipe(
      tap((values) => {
        this.serviceBiller = values;
      }),
    );
  }

  getCatalogByCode(idCode: string): Observable<CatalogItem[]> {
    return this.catalogsHTTPService.getCatalogById({ id: idCode });
  }

  getByIdGroup(groupId: string): Observable<CatalogItem[]> {
    return this.catalogsHTTPService.getCatalogByGroupId({ groupId });
  }

  getInternationalReasons(): Observable<CatalogItem[]> {
    return this.catalogsHTTPService.getCatalogByGroupId({ groupId: CATALOGUE_IDS.INTERNATIONAL_REASONS }).pipe(
      tap((values) => {
        this.internationalReasons = values;
      }),
    );
  }
}
